import { GruppoProjection } from './GruppoProjection'
import { PagedBaseState } from './PagedBaseState'

export class GruppoState extends PagedBaseState<GruppoProjection> {

}